module.exports = __webpack_public_path__ + "img/shippin-history.f9ec54ed.svg";